import { css } from 'styled-components';
import { linkControlledHoverEffect } from './linkControlledHoverEffect';
export const linkHoverEffect = () => css `
  &:hover {
    ${linkControlledHoverEffect}
  }
`;
//# sourceMappingURL=linkHoverEffect.js.map